import { render, staticRenderFns } from "./ViewerApp.vue?vue&type=template&id=707b9e40&"
import script from "./ViewerApp.vue?vue&type=script&lang=ts&"
export * from "./ViewerApp.vue?vue&type=script&lang=ts&"
import style0 from "./ViewerApp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.7_fb85a9817f99bdf862e5e3a442a1fb91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports